export const environment = {
  production: true,
  restApiUrl: 'https://fj4s8caho8.execute-api.eu-west-3.amazonaws.com/prod',
  baseUrl:
    'https://qtqtvhvnnrhvnj4dqhp6ylbm5y.appsync-api.eu-west-3.amazonaws.com/graphql',
  apiKey: 'da2-s4henmr5jfavji3xsk7xyy7grm',
  selfUrl: 'https://cfasante.fr/',
  userPoolId: 'eu-west-3_tNVp0rywK',
  userPoolWebClientId: '21vmd0mniua45dkdqu7hfahj5m',
  region: 'eu-west-3',
  bucket: 'cfa-prod-cfasante-assets-prod',
  identityPoolId: 'eu-west-3:3f84f8f6-27a3-460c-aca8-81522929a0a0',

  aws_exports: {
    region: 'eu-west-3',
    userPoolId: 'eu-west-3_tNVp0rywK',
    userPoolWebClientId: '21vmd0mniua45dkdqu7hfahj5m',
    identityPoolId: 'eu-west-3:3f84f8f6-27a3-460c-aca8-81522929a0a0',
    mandatorySignIn: true
  }
};
